import api from "../api";

// Admin - Get all desktop versions
export const getDesktopVersions = (params) => {
  return api.getApi().get(api.getBaseUrl() + "admin/desktop-versions", { params });
};

// Admin - Get version by ID
export const getDesktopVersionById = (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/desktop-versions/${id}`);
};

// Admin - Upload new version
export const uploadDesktopVersion = (formData) => {
  return api.getApi().post(api.getBaseUrl() + "admin/desktop-versions/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Admin - Update version
export const updateDesktopVersion = (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `admin/desktop-versions/${id}`, data);
};

// Admin - Delete version
export const deleteDesktopVersion = (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/desktop-versions/${id}`);
};

// Admin - Get download stats
export const getDesktopStats = () => {
  return api.getApi().get(api.getBaseUrl() + "admin/desktop-versions/stats");
};

// Public - Get latest version
export const getLatestDesktopVersion = () => {
  return api.getApi().get(api.getBaseUrl() + "desktop-app/latest");
};

// Public - Track download
export const trackDesktopDownload = (id) => {
  return api.getApi().post(api.getBaseUrl() + `desktop-app/${id}/download`);
};

